import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { 
  collection, 
  addDoc, 
  getDocs, 
  deleteDoc, 
  doc, 
  serverTimestamp, 
  query, 
  orderBy 
} from 'firebase/firestore';

const GOLD = '#B8860B';

export default function AdminVaultManager() {
  const [name, setName] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [status, setStatus] = useState('');
  const [vaultItems, setVaultItems] = useState([]);

  // 1. Fetch current items for the "Delete" gallery
  const fetchVault = async () => {
    const q = query(collection(db, 'style_vault'), orderBy('createdAt', 'desc'));
    const snap = await getDocs(q);
    setVaultItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => {
    fetchVault();
  }, []);

  const handleManualUpload = async (e) => {
    e.preventDefault();
    setStatus('Uploading...');
    try {
      await addDoc(collection(db, 'style_vault'), {
        name,
        imageUrl,
        createdAt: serverTimestamp()
      });
      setName(''); setImageUrl('');
      setStatus('✅ Style Added!');
      fetchVault(); // Refresh list
    } catch (err) { setStatus('❌ Error: ' + err.message); }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to remove this style from the vault?")) {
      try {
        await deleteDoc(doc(db, 'style_vault', id));
        fetchVault(); // Refresh list
      } catch (err) { alert("Delete failed: " + err.message); }
    }
  };

  return (
    <div style={container}>
      <h2 style={{ color: GOLD, letterSpacing: '2px' }}>VAULT CONTROL CENTER</h2>
      
      {/* FORM SECTION */}
      <form onSubmit={handleManualUpload} style={card}>
        <h3 style={{ marginTop: 0 }}>Add New Trend</h3>
        <div style={formRow}>
          <input style={input} placeholder="Style Name" value={name} onChange={e => setName(e.target.value)} required />
          <input style={input} placeholder="Image URL" value={imageUrl} onChange={e => setImageUrl(e.target.value)} required />
          <button type="submit" style={uploadBtn}>UPLOAD</button>
        </div>
        {status && <p style={{ color: GOLD, fontSize: '0.8rem' }}>{status}</p>}
      </form>

      {/* DELETE / MANAGEMENT SECTION */}
      <h3 style={{ color: GOLD, marginTop: '40px' }}>Current Vault Items ({vaultItems.length})</h3>
      <div style={grid}>
        {vaultItems.map(item => (
          <div key={item.id} style={itemCard}>
            <img src={item.imageUrl || item.image} alt={item.name} style={previewImg} />
            <div style={itemInfo}>
              <p style={itemName}>{item.name}</p>
              <button onClick={() => handleDelete(item.id)} style={deleteBtn}>REMOVE</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// STYLES
const container = { padding: '40px', background: '#050a0f', minHeight: '100vh', color: 'white', fontFamily: 'sans-serif' };
const card = { background: '#0a0f14', padding: '24px', borderRadius: '15px', border: '1px solid #1a1a1a' };
const formRow = { display: 'flex', gap: '10px', flexWrap: 'wrap' };
const input = { flex: 1, minWidth: '200px', padding: '12px', borderRadius: '8px', border: '1px solid #333', background: '#111', color: 'white' };
const uploadBtn = { background: GOLD, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' };
const grid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '20px', marginTop: '20px' };
const itemCard = { background: '#0a0f14', borderRadius: '12px', overflow: 'hidden', border: '1px solid #1a1a1a' };
const previewImg = { width: '100%', height: '150px', objectFit: 'cover' };
const itemInfo = { padding: '12px', textAlign: 'center' };
const itemName = { fontSize: '0.8rem', margin: '0 0 10px 0', fontWeight: 'bold' };
const deleteBtn = { background: '#ff4444', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', fontSize: '0.7rem', cursor: 'pointer', width: '100%' };
